import apiSlice from "./ApiSlice";

export const recordingRulesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all
    getAllRecordingRules: builder.query({
      providesTags: ["recording-rule"],
      query: (body) => {
        return {
          url: "/recording-rule",
          method: "POST",
          body,
        };
      },
    }),

    // GET BY ID Recording
    getRecordingRulesById: builder.query({
      providesTags: ["recording-rule"],
      query: (id) => {
        return {
          url: `/recording-rule/${id}`,
          method: "GET",
        };
      },
    }),
    // GET BY ID STUDENT
    getStudentByBatchId: builder.query({
      query: (id) => {
        return {
          url: `/admission/get-by-batch/${id}`,
          method: "GET",
        };
      },
    }),
    // Add
    addRecordingRules: builder.mutation({
      invalidatesTags: ["recording-rule"],
      query: (body) => {
        return {
          url: "/recording-rule/add",
          method: "POST",
          body,
        };
      },
    }),

    // UPDATE
    updateRecordingRules: builder.mutation({
      invalidatesTags: ["recording-rule"],
      query: ({ body, id }) => {
        return {
          url: `/recording-rule/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // Delete
    deleteRecordingRules: builder.mutation({
      invalidatesTags: ["recording-rule"],
      query: (id) => {
        return {
          url: `/recording-rule/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useGetAllRecordingRulesQuery,
  useGetRecordingRulesByIdQuery,
  useAddRecordingRulesMutation,
  useUpdateRecordingRulesMutation,
  useDeleteRecordingRulesMutation,
  useGetStudentByBatchIdQuery,
} = recordingRulesApi;
